import React, { useEffect, useState } from "react";
import SettingPersonalInfo from "./Setting_UI/PersonalInfo";
import SettingDependant from "./Setting_UI/Dependant";
import SettingHMO from "./Setting_UI/SettingHMO";
import SettingEmergencyContact from "./Setting_UI/EmergencyContact";
import Password from "./Setting_UI/Setting_password"; // Import Password component
import { get } from "../../utility/fetch";
import Spinner from "../Spinner";

const SettingsPage = () => {
    const [activeSection, setActiveSection] = useState("personal");
    const [personalInfo, setPersonalInfo] = useState([]);
    const [dependant, setDependant] = useState([]);
    const [emergencyContact, setEmergencyContact] = useState([]);
    const [insurance, setInsurance] = useState([]);
    const [groupLoading, setGroupLoading] = useState(false);
    const [contact, setContact] = useState([]);

    const getPersonalInfo = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Patient/myprofile`);
            if (response.status === 'success') {
                setPersonalInfo(response?.data);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    const getContact = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Patient/contact`);
            if (response.status === 'success') {
                setPersonalInfo((prevInfo) => ({
                    ...prevInfo,
                    ...response?.data, // Merge contact data into personalInfo
                }));
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching contact data:", error);
        }
    };

    const getEmergencyContact = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Patient/emergencycontact`);
            if (response.status === 'success') {
                setEmergencyContact(response?.data);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    const getHMO = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Patient/hmo`);
            if (response.status === 'success') {
                setInsurance(response?.data);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    const getDependant = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Community/list`);
            if (response.status === 'success') {
                setDependant(response?.data);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    useEffect(() => {
        setGroupLoading(true);
        getPersonalInfo();
        getContact();
        getEmergencyContact();
        getHMO();
        getDependant();
        setGroupLoading(false);
    }, []);

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderActiveSection = () => {
        switch (activeSection) {
            case "personal":
                return <SettingPersonalInfo data={personalInfo} />;
            case "dependant":
                return <SettingDependant data={dependant} />;
            case "emergency":
                return <SettingEmergencyContact id={personalInfo?.id} data={emergencyContact} email={personalInfo?.email} pic={personalInfo?.pictureUrl} name={personalInfo?.fullName} />;
            case "insurance":
                return <SettingHMO data={insurance} email={personalInfo?.email} pic={personalInfo?.pictureUrl} name={personalInfo?.fullName} />;
            case "password": // Add case for password
                return <Password />;
            default:
                return <div className="card p-40 center-text">Coming Soon...</div>;
        }
    };

    return (
        <div className="w-100 p-4">
            <div>
                <a href="#" className="back-link">Back to Home Page</a>
                {/* <h1 className="title">Settings</h1>
                <p className="subtitle">Lorem ipsum dolor sit amet consectetur.</p> */}
            </div>



            <h2 className="section-title m-t-40">Profile Settings</h2>
            <p className="description m-b-20">
                Lorem ipsum tellus tristique venenatis amet integer pulvinar habitasse
                parturient amet sit.
            </p>

            <div className="flex">
                <div className="profile-container col-3">
                    <aside className="card no-margin filter-buttons flex flex-direction-v">
                        <button className={activeSection === "personal" ? "active" : ""} onClick={() => setActiveSection("personal")}>
                            Personal Information
                        </button>
                        {/* <button className={activeSection === "dependant" ? "active" : ""} onClick={() => setActiveSection("dependant")}>
                         Dependant Profile
                     </button> */}
                        <button className={activeSection === "emergency" ? "active" : ""} onClick={() => setActiveSection("emergency")}>
                            Emergency Contact
                        </button>
                        {/* <button className={activeSection === "insurance" ? "active" : ""} onClick={() => setActiveSection("insurance")}>
                         Insurance Profile
                     </button> */}
                        <button className={activeSection === "password" ? "active" : ""} onClick={() => setActiveSection("password")}>Password</button>
                        <button className={activeSection === "billing" ? "active" : ""} onClick={() => setActiveSection("billing")}>Billing</button>
                        <button className={activeSection === "faq" ? "active" : ""} onClick={() => setActiveSection("faq")}>FAQ</button>

                    </aside>
                </div>
                <div className="col-9">
                    {groupLoading ?
                        <Spinner />
                        :
                        renderActiveSection()}
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
